import {
  DeviceMobile,
  Download,
  File,
  Files,
  Folder,
  IconContext,
  Layout,
  Lock,
  StackSimple,
  Swatches,
  TextAa,
} from "@phosphor-icons/react";
import { cn, templatesList } from "@reactive-resume/utils";
import { motion } from "framer-motion";

type Feature = {
  icon: React.ReactNode;
  title: string;
  className?: string;
};

const featureLabel = cn(
  "flex cursor-default items-center justify-center gap-x-2 rounded bg-secondary px-4 py-3 text-sm font-medium leading-none text-primary transition-colors hover:bg-primary hover:text-background",
);

export const FeaturesSection = () => {
  const templatesCount = templatesList.length;

  const features: Feature[] = [
    { icon: <File />, title: "ATS-Friendly Templates" },
    { icon: <DeviceMobile />, title: "Easy Payment Methods" },
    { icon: <Download />, title: "Download Instantly" },
    { icon: <StackSimple />, title: `${templatesCount} Professional Templates` },
    { icon: <Files />, title: "Single or Multi-Page Resumes" },
    { icon: <Folder />, title: "Manage Multiple Resumes" },
    { icon: <Swatches />, title: "Customizable Colors" },
    { icon: <Layout />, title: "Drag & Drop Layouts" },
    { icon: <TextAa />, title: "Google Fonts Integration" },
    { icon: <File />, title: "A4 & Letter Formats" },
    { icon: <Lock />, title: "Secure & Private" },
  ];

  return (
    <section id="features" className="relative bg-secondary-accent py-24 sm:py-32">
      <div className="container">
        <div className="space-y-6 leading-loose">
          <h2 className="text-4xl font-bold">
            Everything You Need to Create a Professional Resume
          </h2>
          <p className="max-w-4xl text-base leading-relaxed">
            VillageHut Resume Builder provides all the tools you need to create a standout resume
            that gets you noticed by employers.
          </p>

          <IconContext.Provider value={{ size: 14, weight: "bold" }}>
            <div className="!mt-12 flex flex-wrap items-center gap-4">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  viewport={{ once: true }}
                  initial={{ opacity: 0, x: -50 }}
                  className={cn(featureLabel, feature.className)}
                  whileInView={{ opacity: 1, x: 0, transition: { delay: index * 0.1 } }}
                >
                  {feature.icon}
                  <h4>{feature.title}</h4>
                </motion.div>
              ))}
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </section>
  );
};
